export enum SettingsType {
  Page = 'page:',
  Section = 'section:'
}
